import { User } from "@models/user.model";
import { File } from "@app/tool/model/file.model";
import { Tool } from "@app/tool/model/tool.model";
import { TicketOperationTask } from "./ticket-operation-tasks.model";
import { TicketOperationRecurrences } from "./ticket-operation-recurrences.model";
import { TicketOperationTool } from "@models/ticket-operation-tool.model";

export class TicketOperation {

    public id: number;
    public name: string;
    public startDate: Date;
    public endDate: Date;
    public assignedTo: User;
    public comment: string;
    public document: File;
    public instructionFile: File;
    public description: string;
    public priority: number;
    public status: string;
    public isClosed: boolean;
    public ticketId: number;
    public operationId: number;
    public nrOfTasks: number;
    public ticketOperationTools: TicketOperationTool[];
    public ticketOperationTasks: TicketOperationTask[];
    public ticketOperationRecurrences: TicketOperationRecurrences[];

    constructor(ticketOperation: any = {}) {
        if (!ticketOperation) {
            return new TicketOperation();
        }
        this.id = ticketOperation.id || 0;
        this.name = ticketOperation.name || '';
        this.startDate = ticketOperation.startDate;
        this.endDate = ticketOperation.endDate;
        this.assignedTo = this.mapUser(ticketOperation.assignedTo);
        this.comment = ticketOperation.comment || '';
        this.document = ticketOperation.document;
        this.instructionFile = ticketOperation.instructionFile;
        this.description = ticketOperation.description;
        this.priority = ticketOperation.priority;
        this.status = ticketOperation.status || '';
        this.isClosed = ticketOperation.isClosed || false;
        this.ticketId = ticketOperation.ticketId || 0;
        this.operationId = ticketOperation.operationId || 0;
        this.nrOfTasks = ticketOperation.nrOfTasks || 0;
        this.ticketOperationTasks = this.mapTicketOperationTasks(ticketOperation.ticketOperationTasks);
        this.ticketOperationRecurrences = this.mapTicketOperationRecurrences(ticketOperation.ticketOperationRecurrences);
        this.ticketOperationTools = this.mapTicketOperationTools(ticketOperation.ticketOperationTools);
    }

    mapUser(user) {
        return user ? new User(user) : new User();
    }

    private mapTicketOperationTools(ticketOperationTools = []) {
        return ticketOperationTools.map((tot) => new TicketOperationTool(tot));
    }

    mapTicketOperationTasks(ticketOperationTasks = []) {
        return ticketOperationTasks.map((tot) => new TicketOperationTask(tot));
    }

    mapTicketOperationRecurrences(ticketOperationRecurrences = []) {
        return ticketOperationRecurrences.map((tor) => new TicketOperationRecurrences(tor));
    }

    static get type() {
        return 'ticket-operations';
    }

    get inProgress() {
        return this.status === 'InProgress';
    }
}
